import { Card } from "antd";
import React from "react";

const TermsAndConditions = () => {
  return (
    <>
      <div className="bg-primaryPurple h-full py-4 px-4">
        <div className="bg-primaryPurple px-4 pb-4">
          <h1 className="text-lg my-0 py-2 font-medium tracking-wider text-white">
            Terms and Conditions
          </h1>
          <Card className="flex border-solid border-inputFieldGrey rounded-sm items-center lg:col-span-2 p-5">
            <p className="text-var(--background, #19161B) font-Satoshi text-base font-light leading-6 tracking-tight">
              Terms and Conditions for Yupup App for Business Vendors These
              terms and conditions ("Agreement") govern your use of the Yupup
              App ("App") as a business vendor. By accessing or using the
              WebApp, you agree to be bound by these terms and conditions. If
              you do not agree with any part of these terms and conditions, you
              may not use the App. <br /> <br />
              <b>1. Account Registration: </b>
              <br />
              a. To use the App as a business vendor, you must create an account
              and provide accurate and complete information.
              <br /> b. You are responsible for maintaining the confidentiality
              of your account login credentials and all activities under your
              account.
              <br />
              c. You agree to notify us immediately of any unauthorized use of
              your account or any other security breach. <br /> <br />
              <b>2. Vendor Responsibilities:</b>
              <br /> a. As a business vendor, you are solely responsible for the
              products or services you offer through the App.
              <br /> b. You agree to comply with all applicable laws,
              regulations, and industry standards. <br />
              c. You are responsible for ensuring the accuracy and completeness
              of your product or service listings.
              <br /> d. You agree to provide high-quality customer service and
              promptly address any customer complaints or issues.
              <br /> <br />
              <b>3. App Usage:</b> <br />
              a. You may use the App solely for the purpose of promoting and
              selling your products or services.
              <br /> b. You may not use the App for any illegal, fraudulent, or
              unauthorized purposes.
              <br /> c. You may not interfere with or disrupt the operation of
              the App or its associated systems. d. You may not use any
              automated means, such as bots or scrapers, to access or collect
              data from the App. <br /> <br />
              <b>4. Intellectual Property:</b> <br />
              a. The App and all its content, including but not limited to text,
              graphics, logos, and images, are the property of Yupup or its
              licensors and are protected by intellectual property laws.
              <br />
              b. You may not use, reproduce, modify, or distribute any content
              from the App without prior written permission from Yupup. <br />{" "}
              <br />
              <b>5. Fees and Payments:</b>
              <br /> a. Yupup may charge fees for certain services or
              transactions conducted through the App. You agree to pay all
              applicable fees promptly. b. Yupup reserves the right to modify
              the fees or introduce new fees at any time, with prior notice.
              <br /> <br />
              <b>6. Termination:</b>
              <br /> a. Yupup may terminate or suspend your account and access
              to the App at any time, without prior notice, for any reason.{" "}
              <br />
              b. You may terminate your account by providing written notice to
              Yupup.
              <br /> c. Upon termination, all rights and licenses granted to you
              under this Agreement will immediately cease.
              <br /> <br />
              <b>7. Limitation of Liability:</b> <br />
              a. Yupup shall not be liable for any direct, indirect, incidental,
              consequential, or punitive damages arising from or in connection
              with your use of the App. <br />
              b. Yupup does not guarantee the availability, accuracy, or
              reliability of the App or its content. <br />
              <br /> <b>8. Governing Law:</b> <br />
              a. This Agreement shall be governed by and construed in accordance
              with the laws of [Jurisdiction].
              <br /> b. Any disputes arising out of or in connection with this
              Agreement shall be subject to the exclusive jurisdiction of the
              San Francisco Superior Court . By using the Yupup WebApp as a
              business vendor, you acknowledge that you have read, understood,
              and agree to be bound by these terms and conditions.
            </p>
          </Card>
        </div>
      </div>
    </>
  );
};

export default TermsAndConditions;
